//have to modify according to my needs
import {
  REQUEST_ORGANISATIONS,
  RESPONSE_ORGANISATIONS,
  FAILURE_ORGANISATIONS,
  RELATED_CORPORATE_LINKS_CHANGE,
  MULTI_CORPORATE_CHANGE
} from "../../actions/types";

const initialState = {
  isMultiSearch: false,
  isFetching: false,
  error: false,
  statusCode: 0,
  isInitalScreen: true,
  relatedCorporates: [],
  multiCorporates: []
};

const setFetching = (state, action) => {
  return {
    ...state,
    isFetching: true,
    keyword: action.payload.keyword,
    isInitalScreen: false,
    statusCode: 0,

    relatedCorporates: [],
    multiCorporates: []
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    keyword: action.payload.keyword,
    relatedCorporates: [],
    multiCorporates: []
  };
};

const setRelatedCorporateLinks = (state, action) => {
  const relatedCorporates = action.payload.relatedCorporates || [];
  let statusCode = action.payload.statusCode;
  return {
    ...state,
    relatedCorporates,
    statusCode,

    multiCorporates: [],
    isFetching: false,
    error: false,
  };
};

const setMultiCorporates = (state, action) => {
  const multiCorporates = action.payload.relatedCorporates || [];

  return {
    ...state,
    multiCorporates
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_ORGANISATIONS:
      return setFetching(state, action);
      break;

    case RESPONSE_ORGANISATIONS:
      return setRelatedCorporateLinks(state, action);
      break;

    case FAILURE_ORGANISATIONS:
      return setFailure(state, action);
      break;
    // case RELATED_CORPORATE_LINKS_CHANGE:
    //   return setRelatedCorporateLinks(state, action);
    //   break;

    case MULTI_CORPORATE_CHANGE:
      return setMultiCorporates(state, action);

    default:
      return state;
      break;
  }
};
